<template>
	<div>
		<!-- 评论输入框使用插件待定 -->
		<el-input type="textarea" class="comment" :rows="4"  @focus="empty=false" :placeholder="placeholder?placeholder:'请输入内容'" v-model="comment"></el-input>
		<!-- 表情弹框打开按钮 -->
		<span class="EmotionButton" @click="OpenEmotion()">
		    <i class="iconfont icon-biaoqing"></i>
		</span>
		<div class="EmoticonListCover" v-if="Show" >
		    <div class="EmoticonList">
		        <div class="PicItem" v-for="(item,i) in EmotionList" @click="ClickEmoticon(i)" :key="i">
		            <img :src=" 'https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/' + i + '.gif'">
		        </div>
		    </div>
		</div>
		<el-button  class="publish-btn" type="warning" size="medium" @click="publish()">发布</el-button>
	</div>
</template>

<script>
  import emotions from '@/utils/emoji.js'
  import { publishCommit } from '@/api/social/index'
  import { toLogin } from '@/api/isLogin'
  import { getIsTrial, getToken } from '@/utils/auth'
  export default {
    name: "Emotion",
	props: {
	  placeholder: { 
		type: String,
		default: ''
	  },
	  empty: {
		  type: Boolean,
		  default: false
	  },
	  data: {
		type: Object,
		default: null
	  },
	  topicId:{
		type: String,
		default: ''  
	  }
	},
    data:function(){
      return {
        Show:false,
        EmotionList:[],
		comment: '',
		commitContent: ''
      }
    },
    methods:{
      //选中表情
      ClickEmoticon:function (EmoticonNo) {
        this.Show = false;
		this.comment += '[[' + this.EmotionList[EmoticonNo] + ']]';
        this.$emit('AppendInputValue',this.comment);
      },
	  handelChange(){
		this.$emit('AppendInputValue',this.comment);  
	  },
      OpenEmotion:function (Value) {
        this.Show = !this.Show;
      },
	  async publish(){
	  	if(getToken()){
	  		// this.emptyValue = true
			if(!this.comment){
				this.$message.error('评论内容不得为空')
				return
			}
			var arr = this.comment.split('[[')
			arr.forEach((v,i)=>{
				this.EmotionList.forEach((val,index) =>{
					if(v.indexOf(val)!==-1){
						v = v.replace(`${val}]]`,`<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/${index}.gif">`)
						this.$set(arr,i,v)
					}
				})
				
			})
			if(/[\u4e00-\u9fff]/.test(arr.join(''))){
			  this.commitContent = '<p>'+arr.join('')+'</p>';
			}else{
			  this.commitContent = arr.join('');
			}
		
	  		const res = await publishCommit({
	  			"isComment": this.data?"0":'1',
	  			"isReply": this.data?"1":'0',
	  			"sendContent": this.commitContent,
	  			"replyUser": this.data?this.data.sendUser:'',
	  			"topicId": this.topicId,
	  			"parentId": this.data?this.data.parentId=='0'?this.data.id:this.data.parentId:'0',
	  		})
	  		if (res.code === 0) {
	  			this.comment = ''
	  			if(this.data){
	  				this.data.showInput = false
	  				this.$message.success('已成功回复')
	  			}else{
	  				this.$message.success('已成功发表评论')
	  			}
	  			this.$emit('returnRes', true);
	  		} else {
	  		  this.$message.error(res.msg)
	  		}
	  	}else{
	  		toLogin(this)
	  	}
	  	
	  },
    },
	watch:{
		empty(newV){
			if(newV) this.comment = ''
		}
	},
	mounted(){
		this.EmotionList = emotions.emotionList
	}
  }
</script>

<style lang="scss">
.PicItem{
	display: inline-block;
}
.icon-biaoqing{
	margin-top: 10px;
	color: #94989E;
	font-size: 22px;
}
.comment{
	margin-bottom: 5px;
}
.EmoticonListCover{
	background-color: #fff;
	border-radius: 5px;
	z-index: 9;
}
.publish-btn{
	// margin-top: -25px;
	float: right;
	background-color: #FF842E;
}
.el-textarea__inner:focus{
	border-color: #C0C4CC;
}
</style>